interface vitalographInterface {
  value: number;
  units: string;
}

export interface metricsInterface {
  systolic?: number;
  diastolic?: number;
  pulse?: number;
  glucose?: number;
  units?: string;
  weight?: number;
  spo2?: number;
  spirometry?: string;
  temp?: number;
  type?: string;
  meal?: string;
  unit?: string;
  description?: string;
  imei?: string;
  macAddress?: string;
  fev1?: vitalographInterface;
  fvc?: vitalographInterface;
  pef?: vitalographInterface;
  steps?: number;
}

export interface ReadingContextInterface {
  id: string;
  type: string;
  metrics?: metricsInterface;
  measuredAt?: string;
  updatedAt?: string;
  value?: string;
  date?: string;
}

export const readingContext = {
  id: "",
  type: "",
  metrics: {},
  measuredAt: ""
};
